import { COLORS } from '@cuemath/comps';

const toRGB = hex => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return result
    ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)]
    : null;
};

export const toRGBA = (hex, alpha) => {
  const rgb = toRGB(hex);

  return rgb ? `rgba(${rgb.join(', ')}, ${alpha})` : null;
};

export default COLORS;
